export const TKeyFields = {
  FIRSTNAME: "FIRSTNAME",
  LASTNAME: "LASTNAME",
  EMAIL: "EMAIL",
  PASSWORD: "PASSWORD",
  NEW_PASSWORD: "NEW_PASSWORD",
  REPEAT_PASSWORD: "REPEAT_PASSWORD",
  PHONE: "PHONE",
  LINK: "LINK",
  JOB_TITLE: "JOB_TITLE",
  BIO: "BIO",
  PLACEHOLDER_FIRSTNAME: "PLACEHOLDER_FIRSTNAME",
  PLACEHOLDER_LASTNAME: "PLACEHOLDER_LASTNAME",
  PLACEHOLDER_JOB_TITLE: "PLACEHOLDER_JOB_TITLE",
  PLACEHOLDER_BIO: "PLACEHOLDER_BIO",
  PLACEHOLDER_PHONE: "PLACEHOLDER_PHONE",
  PLACEHOLDER_LINK: "PLACEHOLDER_LINK",
} as const;
